class MoveWpmlSwitcherMobile {
	constructor() {
		this.switcher = document.querySelector('.mobile-menu .wpml-ls-item');
		this.mobileNavbar = document.querySelector('.mobile-menu');
		
		this.run();
	}

	run() {
		this.mobileNavbar.insertBefore(this.switcher, this.mobileNavbar.firstChild);
	}
}

export default MoveWpmlSwitcherMobile;
